import React from 'react';
import logo from '../Header/fitinsur-logo.svg';

import { Wrapper, Container, Logo, Website } from './styles';

export default function Footer() {
  return (
    <Wrapper>
      <Container>
        <Website>www.fitinsur.com.br</Website>
        <Logo src={logo} />
      </Container>
    </Wrapper>
  );
}
